import { Mapper } from 'src/base/mapper'
import { HasSubscriptionTypeEntity } from 'src/data/entities/subscription.entity'
import { HasSubscriptionTypeModel } from 'src/domain/models/subscription.model'

export class HasSubscriptionMapper extends Mapper<HasSubscriptionTypeEntity, HasSubscriptionTypeModel> {
	mapFrom(param: HasSubscriptionTypeEntity): HasSubscriptionTypeModel {
		return this.resultData(param)
	}

	mapTo(param: HasSubscriptionTypeModel): HasSubscriptionTypeEntity {
		return this.resultData(param)
	}

	resultData(param: HasSubscriptionTypeEntity | HasSubscriptionTypeModel) {
		return {
			hasSubscription: param.hasSubscription,
			status: param.status,
		}
	}
}
